import * as constants from '../../../constants'
import cx from 'classnames'
import { getFilteredAttrs, renderAttrValue } from './ItemDataCategoryTableUtils'
import isUndefined from 'lodash/isUndefined'
import isString from 'lodash/isString'
import React from 'react'
import { processAttrValueForRender } from '../../../utils/textUtils';

const RenderSimpleTextList = ({attributes, type}) => {

    const isRepeatable = type === constants.SECTION_TYPE_REPEATABLE
    const sections = isRepeatable ? attributes : [attributes]

    return sections.map((section, index) => {

        // Controlla se la sezione ha almeno un valore visibile
        const visibleAttrs = getFilteredAttrs(section).filter((attr) => {
            const value = renderAttrValue(attr)
            return value !== null && !isUndefined(value) && value !== ''
        })

        if (visibleAttrs.length === 0) return null;

        return (
            <table
                key={index}
                className={cx(
                    'table table-striped table-striped-alt table-hover table-article-info',
                    {
                        'table-articolo-info-multiple': isRepeatable,
                    }
                )}
            >
                <tbody>
                {getFilteredAttrs(section).map((attr, i) => {
                    const value = renderAttrValue(attr)

                    // debug log
                    // console.warn('value from RenderSimpleTextList => ', value)

                    if (value === null || isUndefined(value) || value === '') {
                        return null;
                    }

                    // Processo il testo, questo per convertire \n e altri caratteri unicode
                    const { text, isHtml } = processAttrValueForRender(attr);

                    const regex = new RegExp(
                        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
                    )

                    return (
                        <tr style={{
                            verticalAlign: 'top',
                        }}
                            key={i}>
                            <td>
                                {attr.label}
                                {isRepeatable && i === 0 ? ` ${index + 1}` : ''}
                            </td>
                            <td>
                                {isString(value) && value.match(regex) ? (
                                    <a
                                        href={value}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {value}
                                    </a>
                                ) : isHtml ? (
                                    <div
                                        className={cx('font-bold')}
                                        style={{
                                            whiteSpace: 'pre-line',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            wordBreak: 'normal',
                                            maxWidth: '100%'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: text }}
                                    />
                                ) : (
                                    <div
                                        className={cx('font-bold')}
                                        style={{
                                            whiteSpace: 'pre-line',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            wordBreak: 'normal',
                                            maxWidth: '100%'
                                        }}
                                    >
                                        {text}
                                    </div>
                                )}
                            </td>

                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    })
}

export default RenderSimpleTextList